// Server documents always live flat inside the "uploads" folder, but some
// legacy/records have the full server filesystem path saved instead of a
// clean relative one (e.g. "C:\inetpub\wwwroot\demo insollex\uploads\file.pdf").
// Pulling out everything from the "uploads" segment onward makes preview/
// download links work regardless of which shape happens to be stored.
export const getUploadsRelativePath = (rawPath) => {
    if (!rawPath) return '';
    const normalized = String(rawPath).replace(/\\/g, '/');

    if (/^https?:\/\//i.test(normalized)) return normalized;

    const match = normalized.match(/uploads\/.*/i);
    if (match) return match[0];

    return `uploads/${normalized.replace(/^\/+/, '')}`;
};
